//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DASHBOARD_PANEL_SHARE_REQUEST,
    DASHBOARD_PANEL_GET_DASHBOARD_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    dashboardPanelGetDashboardResult,
    dashboardPanelShareResult
} from 'Redux/actions';

function* updateDashboard({ payload }) {
    try {
        let QUERY = `
            mutation updateDashboard ($id: String, $name: String!, $sharedWith: String) {
                result: updateDashboard (id: $id, name: $name, sharedWith: $sharedWith) {
                    id
                    name
                    sharedWith
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(dashboardPanelShareResult(data.result))
        }

    } catch (exc) {
        yield put(dashboardPanelShareResult(null))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/shareDashboard/redux/sagas.js', 'searchDashboards');
    }
}

function* getDashboard({ payload }) {
    try {
        let QUERY = `
            query getDashboard ($id: String!) {
                result: getDashboard (id: $id) {
                    id
                    name
                    sharedWith
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload.id
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(dashboardPanelGetDashboardResult(data.result))
        }

    } catch (exc) {
        yield put(dashboardPanelGetDashboardResult(null))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/shareDashboard/redux/sagas.js', 'getDashboard');
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(DASHBOARD_PANEL_SHARE_REQUEST, updateDashboard);
    yield takeEvery(DASHBOARD_PANEL_GET_DASHBOARD_REQUEST, getDashboard);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}